import React, { useState, useEffect } from 'react';
import { Howl } from 'howler';

export default function ChantAudioControl({ shouldPlay, onScrollStart }) {
    const omChantAudio = '/audio/Om_Chant-1x.mp3'; // Adjust path as needed
    const [omChantSound, setOmChantSound] = useState(null);
    const [isPlaying, setIsPlaying] = useState(false);

    useEffect(() => {
        const sound = new Howl({
            src: [omChantAudio],
            volume: 1,
            loop: true,
            preload: true,
            onload: () => console.log('Chant sound preloaded successfully'),
        });
        setOmChantSound(sound);

        return () => sound.unload(); // Cleanup the Howler instance
    }, [omChantAudio]);

    useEffect(() => {
        if (shouldPlay && omChantSound && !omChantSound.playing()) {
            omChantSound.play();
            setIsPlaying(true);
            if (onScrollStart) onScrollStart();
        }
    }, [shouldPlay, omChantSound, onScrollStart]);

    const togglePlayPause = () => {
        if (omChantSound) {
            if (omChantSound.playing()) {
                omChantSound.pause();
                setIsPlaying(false);
            } else {
                omChantSound.play();
                setIsPlaying(true);
            }
        }
    };

    return (
        <button onClick={togglePlayPause} className="chantAudioButton">
            {isPlaying ? 'Pause Chant' : 'Play Chant'}
        </button>
    );
}
